<template>
  <div id="billing-container" v-if="offers.length > 0">
    <Header></Header>
    <section id="billing">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="tab-list">
              <ul class="nav form-list" role="tablist">
                <li :class="{ 'tablist-style': billingStep >= 1 }">
                  <a
                    :class="{ 'nav-link': true, 'active show': billingStep >= 1}"
                    href="#tab-additional"
                    role="tab"
                    data-order="1"
                    data-toggle="tab"
                    id="tab_additional"
                    @click="() => this.$store.state.billing.billingStep = 1"
                  >1</a>
                </li>
                <li :class="{ 'tablist-style': billingStep >= 2 }">
                  <a
                    class="nav-link"
                    href="#tab-payment"
                    role="tab"
                    data-order="2"
                    data-toggle="tab"
                    id="tab_payment"
                    @click="(e) => { if (submitSuccess) {this.$store.state.billing.billingStep = 2} else e.stopPropagation()}"
                  >2</a>
                </li>
                <li :class="{ 'tablist-style': billingStep >= 3 }">
                  <a
                    class="nav-link"
                    href="#tab-confirmation"
                    role="tab"
                    data-order="3"
                    data-toggle="tab"
                    id="tab_confirmation"
                    @click="(e) => { if (submitSuccess) {this.$store.state.billing.billingStep = 3} else e.stopPropagation()}"
                  >3</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="billing-forms">
      <div class="container">
        <form name="create_user_form" id="create_user_form">
          <div class="tab-content" id="tab-1">
            <div
              role="tabpanel"
              class="tab-pane active"
              data-order="1"
              id="tab-additional"
              v-if="billingStep === 1"
            >
              <div class="row justify-content-center align-items-center">
                <div class="col-lg-10">
                  <div class="billing-title">
                    <h2>Plotësoni formën për të vazhduar</h2>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="billing-form">
                  <div class="row justify-content-center align-items-center">
                    <div class="col-lg-12" v-if="selectedPackage !== 7">
                      <div class="form-group">
                        <div class="styled-input-single">
                          <input
                            type="radio"
                            name="fieldset-3"
                            id="radio-example-five"
                            @click="getSubscriberType('individual')"
                            :checked="this.user() ? this.user().is_business === false : true"
                          />
                          <label for="radio-example-five">Person Individual</label>
                        </div>
                        <div class="styled-input-single">
                          <input
                            type="radio"
                            name="fieldset-3"
                            id="radio-example-six"
                            @click="getSubscriberType('company')"
                            :checked="this.user() ? this.user().is_business === true : false"
                          />
                          <label for="radio-example-six">Biznes/Institucion</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <hr v-if="selectedPackage !== 7" />
                    </div>
                    <div
                      class="col-12"
                      v-if="selectedPackage === 7 || subscriberType === 'individual'"
                    >
                      <label>Plotësoni të dhënat personale</label>
                      <div class="row form-group ">
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            type="text"
                            name="first_name"
                            placeholder="emri"
                            :value="firstName"
                            @input="getFirstName"
                            :class="{'is-invalid' : this.errors['firstName'] }"
                            required
                          />

                          <p v-if="this.errors['firstName']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani emrin</small>
                          </p>
                        </div>

                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            type="text"
                            name="mbiemri"
                            placeholder="mbiemri"
                            :value="lastName"
                            @input="getLastName"
                            required
                            :class="{'is-invalid' : this.errors['lastName'] }"
                          />
                          <p v-if="this.errors['lastName']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani mbiemrin</small>
                          </p>

                        </div>

                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            type="email"
                            placeholder="e-mail"
                            name="email"
                            :value="email"
                            @input="getEmail"
                            required
                            :class="{'is-invalid' : this.errors['email'] }"
                          />
                          <p v-if="this.errors['email']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani emailin</small>
                          </p>
                        </div>
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            type="number"
                            name="phone_number"
                            placeholder="nr i telefonit"
                            :value="phoneNumber"
                            @input="getPhoneNumber"
                            required
                            :class="{'is-invalid' : this.errors['phoneNumber'] }"
                          />
                          <p v-if="this.errors['phoneNumber']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani numrin e telefonit</small>
                          </p>

                        </div>

                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            type="number"
                            name="id_personale"
                            placeholder="ID Personale"
                            :value="personalId"
                            @input="getPersonalId"
                            required
                            :class="{'is-invalid' : this.errors['personalId'] }"
                          />
                          <p v-if="this.errors['personalId']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani nr. personal të ID</small>
                          </p>

                        </div>
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            type="text"
                            name="address"
                            placeholder="adresa"
                            :value="address"
                            @input="getAddress"
                            required
                            :class="{'is-invalid' : this.errors['address'] }"
                          />
                          <p v-if="this.errors['address']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani adresen</small>
                          </p>

                        </div>
                      </div>
                        <div class="form-group terms-conditions">
                            <input :checked="billing_same" type="checkbox" id="billing_same" name="billing_same" @click="billing_same = !billing_same"/>
                            <label for="billing_same"></label>Adresa e faturimit e njëjtë me adresen e banimit?
                        </div>
                        <div class="form-group">
                            <input v-if="billing_same != true" type="text" name="billing_address" 
                                placeholder="adresa e faturimit" v-model="billing_address" required 
                                :class="{'is-invalid' : this.errors['billing_address'] }"/>
                        </div>
                      <hr/>
                      <div class=" row form-group">
                       <div v-if="!this.$store.state.billing.referral_code" class="col-12 col-md-6">
                         <select @change="getSelectedReferral($event)"
                              class="select-cars full-width mb-0"
                              name="vehicle-type"
                              >
                              <option class="text-dark" value selected
                                >{{ disableReferralCodeInput ? 'Zgjedh referuesin' : 'Shkruaj kodin' }}</option
                              >
                              <option v-for="referral in referralsList" class="text-dark" v-bind:key="referral"
                                >{{referral}}</option
                              >
                         </select>
                       </div>
                        <div v-if="disableReferralCodeInput" class="d-flex justify-content-between col-12 col-md-6">
                          <input
                             :class="getReferralInputClass"
                             placeholder="Kodi i referuesit" class="width-40"
                             name="referral_code"
                             :value="referral_code"
                             @keyup.enter="checkReferralCode()"
                             @input="getReferralCode"
                          />
                          <input class="btn-warning col-4" type="button" @click="checkReferralCode" value="Verifiko Kodin"/>
                        </div>
                        <input v-if="isReferrerAgent"
                               class="mx-3"
                               name="referring_email"
                               placeholder="Email i referuesit (opsionale)"
                               :value="referrer"
                               @input="getReferrer"
                        />
                      </div>
                      
                      <hr/>
                    </div>
                    <div
                      class="col-12"
                      v-if="subscriberType === 'individual' && selectedPackage !== 7"
                    >
                      <label>Të dhënat e automjetit</label>
                      <div class="row form-group">
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            name="targat"
                            type="text"
                            placeholder="targat e automjetit"
                            :value="registrationNr"
                            @input="getRegistrationNr"
                            required
                            :class="{'is-invalid' : this.errors['registrationNr'] }"
                          />
                          <p v-if="this.errors['registrationNr']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani regjistrimin e automjetit</small>
                          </p>
                        </div>
                        <div class="col-12 col-md-6">
                          <select
                              class="mb-0"
                            name="payment-term"
                            @change="getCarType"
                            :value="carType"
                            :class="{'is-invalid' : this.errors['carType'] }"
                          >
                            <option disabled value name="car_type">Zgjedh llojin e automjetit</option>
                            <option
                              v-for="brand in brandNames"
                              :key="brand"
                              :value="brand"
                              :disabled="brand === ''"
                            >{{ brand }}</option>
                          </select>
                          <p v-if="this.errors['carType']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Zgjedh llojin e automjetit</small>
                          </p>
                        </div>
                        <div class="col-12 col-md-6">
                          <select
                              class="mb-0"
                            name="payment-term"
                            @change="getRegistrationYear"
                            :value="registrationYear"
                            :class="{'is-invalid' : this.errors['registrationYear'] }"
                          >
                            <option name="prod_year" value disabled>Zgjedh vitin e prodhimit</option>
                            <option
                              v-for="i in yearsList"
                              :key="i"
                              :value="i"
                            >{{ i }}</option>
                          </select>

                          <p v-if="this.errors['registrationYear']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Zgjedh vitin e prodhimit</small>
                          </p>

                        </div>
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                            name="chasis_nr"
                            type="text"
                            placeholder="Pronari Sipas Librezes"
                            :value="chassisNr"
                            @input="getChassisNr"
                            required
                            :class="{'is-invalid' : this.errors['chassisNr'] }"
                            maxlength="17"
                          />
                          <p v-if="this.errors['chassisNr']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani pronarin sipas librezës</small>
                          </p>

                        </div>
                        <div class="col-12 col-md-6">
                          <select
                              class="mb-0"
                            name="payment-term"
                            @change="getTransmission"
                            :value="transmission"
                            :class="{'is-invalid' : this.errors['transmission'] }"
                          >
                            <option value disabled>Zgjedh transmisionin</option>
                            <option value="automatic">Automatik</option>
                            <option value="manual">Manual</option>
                          </select>
                          <p v-if="this.errors['transmission']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Zgjedh llojin e transmisionit</small>
                          </p>

                        </div>
                        <!-- <input
                          name="car_mass"
                          type="number"
                          placeholder="Pesha e automjetit (kg)"
                          :value="volume"
                          @input="getVolume"
                          required
                          :class="{'is-invalid' : this.errors['volume'] }"
                          min="1"
                          max="3000"
                        /> -->
                      </div>
                    </div>
                    <div class="col-12" v-if="subscriberType === 'individual'">
                      <div class="package-price">
                        <div>
                          <h2>{{ handlePrice(getTotalPrice) }} €</h2>
                          <h5>
                            {{ selectedPackagePlan === 'annual' ? 'vjetore' : 'sezonale'}}
                            <br />
                            Pako {{ getPackageName(selectedPackage, offers) }}
                          </h5>
                        </div>
                        <hr/>
                        <div class="form-group">
                          <div class="row" v-if="currentPromotion === null">
                            <div class="col-md-8 col-sm-12 text-left">
                              <input
                                  style="width: 100%"
                                  type="text"
                                  class="m-0"
                                  name="promo_code"
                                  placeholder="Promo Kodi"
                                  :value="promo_code"
                                  @keyup.enter="applyPromoCode()"
                                  @input="getPromoCode"
                              />
                              <p v-if="this.promoCodeError" class="text-danger">
                                <i class="fa fa-exclamation-circle"></i>
                                <small class="pl-2">Promokodi nuk është valid ose është përdorur më parë!</small>
                              </p>
                            </div>
                            <div class="col-md-4 col-sm-12 mt-2 mt-md-0">
                              <div class="btn-next"
                                   style="background-color:#edc239; width:100%; height: 56px; text-align: center; font-weight:bold; padding-top:15px;padding-left:3px;" @click="applyPromoCode">
                                Apliko Kodin
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="discount">
                            <div class="col-12">
                              <span v-if="discount.type ==='amount'"> Keni aplikuar {{ showDiscount(getTotalPrice) ? 'total' : discount.discount }} € zbritje</span>
                              <span v-if="discount.type ==='percentage'">Keni aplikuar {{discount.discount}} % zbritje</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="package-alert" style="margin-top: 0">
                        <p>
                          <strong>Vërejtje:</strong> Ky lloj sigurimi vlen vetëm për mjete motorike deri në 3000kg
                        </p>
                      </div> -->
                      <div class="col-12">
                        <div class="form-group terms-conditions">
                          <input
                              :checked="agreeToTerms"
                              type="checkbox"
                              id="termsandco"
                              name="termsandco"
                              @click="toggleAgreeToTerms"
                              data-toggle="modal" data-target="#agreeTermsModal"
                          />
                          <label for="termsandco"></label>

                          <a
                              href
                              @click="getShowModal(true, $event)"
                          >Une i pranoj Termet dhe Kushtet</a>

                        </div>
                        <popup v-if="showPopup" @close="showPopup = false" >
                        </popup>
                      </div>

                      <div v-if="registrationMessages">
                        <p
                          v-if="registrationMessages === 'did not agree to terms'"
                          style="color: red"
                        >Duhet t'i lexoni kushtet dhe termet para se te perfundoni regjistrimin.</p>
                        <!-- <p
                          v-else-if="registrationMessages.volume"
                          style="color: red"
                        >Pesha e maksimale e automjetit duhet te jete 3000kg</p> -->
                        <p
                          v-else-if="registrationMessages.email"
                          style="color: red"
                        >Shfrytezuesi me kete e-mail ekziston</p>
                        <p
                          v-else-if="registrationMessages.registration_referrer"
                          style="color: red"
                        >Agjenti me kete e-mail nuk mund te gjindet</p>
                        <p v-else-if="registrationMessages" style="color: red">
                          Ka ndodhur nje gabim. Plotesoni te gjitha fushat me te dhenat e sakta per t'u regjistruar me sukses.
                          <br />
                          {{ get_readable(registrationMessages) }}
                        </p>
                      </div>
                    </div>
                    <div class="col-12" v-if="subscriberType === 'company'">
                      <label>Plotësoni të dhënat e Kompanisë</label>
                      <div class="row form-group">
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                              type="text"
                              name="kompania"
                              placeholder="kompania"
                              :value="companyName"
                              @input="getCompanyName"
                              required
                              :class="{'is-invalid' : this.errors['companyName'] }"
                          />
                          <p v-if="this.errors['companyName']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani emrin e kompanisë</small>
                          </p>
                        </div>
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                              type="text"
                              name="business_nr"
                              placeholder="numri i biznesit"
                              :value="businessNumber"
                              @input="getBusinessNumber"
                              required
                              :class="{'is-invalid' : this.errors['businessNumber'] }"
                          />
                          <p v-if="this.errors['businessNumber']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani nr. e biznesit</small>
                          </p>
                        </div>
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                              type="email"
                              placeholder="e-mail"
                              name="c_email"
                              :value="email"
                              @input="getEmail"
                              :class="{'is-invalid' : this.errors['email'] }"
                          />
                          <p v-if="this.errors['email']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani emailin</small>
                          </p>
                        </div>
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                              type="number"
                              name="phone_nr"
                              placeholder="nr i telefonit"
                              :value="phoneNumber"
                              @input="getPhoneNumber"
                              required
                              :class="{'is-invalid' : this.errors['phoneNumber'] }"
                          />
                          <p v-if="this.errors['phoneNumber']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani nr. telefonit</small>
                          </p>
                        </div>
                        <div class="col-12 col-md-6">
                          <input
                              class="mb-0"
                              name="c_address"
                              type="text"
                              placeholder="adresa"
                              :value="address"
                              @input="getAddress"
                              required
                              :class="{'is-invalid' : this.errors['address'] }"
                          />
                          <p v-if="this.errors['address']" class="text-danger">
                            <i class="fa fa-exclamation-circle"></i>
                            <small class="pl-2">Shkruani adresen</small>
                          </p>
                        </div>
                      </div>
                      <div class="form-group terms-conditions">
                            <input :checked="billing_same" type="checkbox" id="billing_same" name="billing_same" @click="billing_same = !billing_same"/>
                            <label for="billing_same"></label>Adresa e faturimit e njëjtë me adresen e banimit?
                        </div>
                        <div class="form-group">
                            <input v-if="billing_same != true" type="text" name="billing_address" 
                                placeholder="adresa e faturimit" v-model="billing_address" required 
                                :class="{'is-invalid' : this.errors['billing_address'] }"/>
                        </div>
                      <hr />
                      <div class=" row form-group">
                        <div v-if="!this.$store.state.billing.referral_code" class="col-12 col-md-6">
                          <select @change="getSelectedReferral($event)"
                                  class="select-cars full-width mb-0"
                                  name="vehicle-type"
                          >
                            <option class="text-dark" value selected
                            >{{ disableReferralCodeInput ? 'Zgjedh referuesin' : 'Shkruaj kodin' }}</option
                            >
                            <option v-for="referral in referralsList" class="text-dark" v-bind:key="referral"
                            >{{referral}}</option
                            >
                          </select>
                        </div>
                        <div v-if="disableReferralCodeInput" class="d-flex justify-content-between col-12 col-md-6">
                          <input
                              :class="getReferralInputClass"
                              placeholder="Kodi i referuesit" class="width-40"
                              name="referral_code"
                              :value="referral_code"
                              @keyup.enter="checkReferralCode()"
                              @input="getReferralCode"
                          />
                          <input class="btn-warning col-4" type="button" @click="checkReferralCode" value="Verifiko Kodin"/><br>
                        </div>
                        <input v-if="isReferrerAgent"
                               name="referring_email"
                               class="mx-3"
                               placeholder="Email i referuesit (opsionale)"
                               :value="referrer"
                               @input="getReferrer"
                        />
                      </div>
                      <hr />
                      <div class="col-12">
                        <label>Të dhënat e automjetit</label>
                        <div class="row form-group" v-for="(vehicle, i) in vehicles" :key="i">
                          <div class="add-cancel">
                            <p>{{ find_index(vehicles, i) }}.</p>
                            <a v-if="find_index(vehicles, i) >= 2" @click="removeVehicleAt(i, $event)">
                              <i class="fas fa-times"></i>
                            </a>
                          </div>
                          <hr />
                          <div class="col-12 col-md-6">
                            <input
                                class="mb-0"
                                type="text"
                                placeholder="targat e automjetit"
                                @input="updateRegistratioNr(i, $event)"
                                :value="vehicles[i].registrationNr"
                                required
                                :class="{'is-invalid' : errors['registrationNr'+i] }"
                            />
                            <p v-if="errors['registrationNr'+i]" class="text-danger">
                              <i class="fa fa-exclamation-circle"></i>
                              <small class="pl-2">Shkruani regjistrimin e automjetit</small>
                            </p>
                          </div>
                          <div class="col-12 col-md-6">
                            <select
                                class="mb-0"
                                name="payment-term"
                                @change="updateCarType(i, $event)"
                                :value="vehicles[i].carType"
                                required
                                :class="{'is-invalid' : errors['carType'+i] }"
                            >
                              <option disabled value>Zgjedh llojin e automjetit</option>
                              <option
                                v-for="brand in brandNames"
                                :key="brand"
                                :value="brand"
                                :disabled="brand === ''"
                              >{{ brand }}</option>
                            </select>
                            <p v-if="errors['carType'+i]" class="text-danger">
                              <i class="fa fa-exclamation-circle"></i>
                              <small class="pl-2">Zgjedh llojin e automjetit</small>
                            </p>
                          </div>
                          <div class="col-12 col-md-6">
                            <select
                                class="mb-0"
                              name="payment-term"
                              @change="updateRegistrationYear(i, $event)"
                              :value="vehicles[i].registrationYear"
                              :class="{'is-invalid' : errors['registrationYear'+i] }"
                            >
                              <option value disabled>Zgjedh vitin e prodhimit</option>
                              <option
                                v-for="year in yearsList"
                                :key="year"
                                :value="year"
                              >{{ year }}</option>
                            </select>
                            <p v-if="errors['registrationYear'+i]" class="text-danger">
                              <i class="fa fa-exclamation-circle"></i>
                              <small class="pl-2">Zgjedh vitin e prodhimit</small>
                            </p>
                          </div>
                          <div class="col-12 col-md-6">
                            <input
                                class="mb-0 pr-1"
                                type="text"
                                placeholder="Pronari sipas Librezes"
                                @input="updateChassisNr(i, $event)"
                                :value="vehicles[i].vehicle_owner_name"
                                required
                                :class="{'is-invalid' : errors['vehicle_owner_name'+i] }"
                                maxlength="17"
                            />
                            <p v-if="errors['vehicle_owner_name'+i]" class="text-danger">
                              <i class="fa fa-exclamation-circle"></i>
                              <small class="pl-2">Shkruani pronarin sipas librezës</small>
                            </p>
                          </div>
                          <div class="col-12 col-md-6">
                            <select
                                class="mb-0"
                              name="payment-term"
                              @change="updateTransmission(i, $event)"
                              :value="vehicles[i].transmission"
                              :class="{'is-invalid' : errors['transmission'+i] }"
                            >
                              <option value disabled>Zgjedh transmisionin</option>
                              <option value="automatic">Automatik</option>
                              <option value="manual">Manual</option>
                            </select>
                            <p v-if="errors['registrationYear'+i]" class="text-danger">
                              <i class="fa fa-exclamation-circle"></i>
                              <small class="pl-2">Zgjedh llojin e transmisionit</small>
                            </p>
                          </div>
                          <!-- <input
                            type="number"
                            placeholder="Pesha e automjetit (kg)"
                            @input="updateVolume(i, $event)"
                            :value="vehicles[i].volume"
                            required
                            :class="{'is-invalid' : errors['volume'+i] }"
                            min="1"
                            max="3000"
                          /> -->
                        </div>
                        <button
                          class="add-car"
                          @click="getVehicleCount(1, $event)"
                        >+ Shto automjet tjeter</button>
                      </div>
                      <div class="col-12" v-if="subscriberType === 'company'">
                        <div class="package-alert" style="margin-top: 0">
                          <p>
                            <strong>Vërejtje:</strong> Ky lloj sigurimi vlen vetëm për mjete motorike deri në 3000kg
                          </p>
                        </div>
                        <div class="package-price">
                          <div>
                            <h2>{{ handlePrice(getTotalPrice) }} €</h2>
                            <h5>
                              {{ selectedPackagePlan === 'annual' ? 'vjetore' : 'sezonale'}}
                              <br />
                              Pako {{ getPackageName(selectedPackage, offers) }}
                            </h5>
                          </div>
                          <hr/>
                          <div class="form-group">
                            <div class="row" v-if="currentPromotion === null">
                              <div class="col-md-8 col-sm-12 text-left">
                                <input
                                    style="width: 100%"
                                    class="m-0"
                                    type="text"
                                    name="promo_code"
                                    placeholder="Promo Kodi"
                                    :value="promo_code"
                                    @keyup.enter="applyPromoCode()"
                                    @input="getPromoCode"
                                />
                                <p v-if="this.promoCodeError" class="text-danger">
                                  <i class="fa fa-exclamation-circle"></i>
                                  <small class="pl-2">Promokodi nuk është valid ose është përdorur më parë!</small>
                                </p>
                              </div>
                              <div class="col-md-4 col-sm-12 mt-2 mt-md-0">
                                <div class="btn-next"
                                     style="background-color:#edc239; width:100%; height: 56px; text-align: center; font-weight:bold; padding-top:15px;padding-left:3px;" @click="applyPromoCode">
                                  Apliko Kodin
                                </div>
                              </div>
                            </div>
                            <div class="row" v-if="discount">
                              <div class="col-12">
                                <span v-if="discount.type ==='amount'">Keni aplikuar {{ showDiscount(getTotalPrice) ? 'total' : discount.discount }} € zbritje</span>
                                <span v-if="discount.type ==='percentage'">Keni aplikuar {{discount.discount}} % zbritje</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group terms-conditions">
                            <input
                              :checked="agreeToTerms"
                              type="checkbox"
                              id="termsandco"
                              name="termsandco"
                              @click="toggleAgreeToTerms"
                              data-toggle="modal" data-target="#agreeTermsModal"
                            />
                            <label for="termsandco"></label>

                            <a
                                href
                                @click="getShowModal(true, $event)"
                            >Une i pranoj Termet dhe Kushtet</a>

                          </div>
                          <popup v-if="showPopup" @close="showPopup = false" >
                          </popup>
                        </div>
                        <div v-if="registrationMessages">
                          <p
                            v-if="registrationMessages === 'did not agree to terms'"
                            style="color: red"
                          >Duhet t'i lexoni kushtet dhe termet para se te perfundoni regjistrimin.</p>
                          <!-- <p
                            v-else-if="registrationMessages.volume"
                            style="color: red"
                          >Pesha e maksimale e automjetit duhet te jete 3000kg</p> -->
                          <p
                            v-else-if="registrationMessages.email"
                            style="color: red"
                          >Shfrytezuesi me kete e-mail ekziston</p>
                          <p
                            v-else-if="registrationMessages.registration_referrer"
                            style="color: red"
                          >Agjenti me kete e-mail nuk mund te gjindet</p>
                          <p v-else-if="registrationMessages" style="color: red">
                            Ka ndodhur nje gabim. Plotesoni te gjitha fushat me te dhenat e sakta per t'u regjistruar me sukses.
                            <br />
                            {{ registrationMessages }}
                            {{ get_readable(registrationMessages) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row align-items-center">
                <div class="col-12">
                  <div class="btn-next">
                    <button href="#tab-payment" class="border-0 register-button" :disabled="disableSubmitButton" @click="requestRegister">Vazhdo</button>
                  </div>
                </div>
              </div>
            </div>
            <div
              role="tabpanel"
              class="tab-pane active"
              data-order="2"
              id="tab-billing"
              v-if="billingStep === 2"
            >
              <div class="row justify-content-center align-items-center">
                <div class="col-lg-10">
                  <div class="billing-title">
                    <h2>Kryeni pagesën për të përfunduar</h2>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="billing-form">
                  <div class="row justify-content-center align-items-center">
                      <div class="col-lg-6">
                          <div class="form-group">
                            <div class="styled-input-single">
                                <input
                                    type="radio"
                                    name="fieldset-4"
                                    id="radio-example-five-o"
                                    :checked="paymentType === 'bank'"
                                    @click="getPaymentType('bank')"
                                />
                                <label for="radio-example-five-o">Paguaj me transfer bankar</label>
                            </div>
                        </div>
                      </div>
                      
                    <div class="col-lg-6">
                      <div class="form-group">
                        <div class="styled-input-single">
                          <input
                            type="radio"
                            name="fieldset-4"
                            id="radio-example-six-o"
                            :checked="paymentType === 'online'"
                            @click="getPaymentType('online')"
                          />
                          <label for="radio-example-six-o">Paguaj me kartelë</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-if="paymentType !== ''">
                      <hr />
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <div style="width:100%; text-align:right;">
                          <button
                            style="padding: 10px 10px; margin-bottom: 10px;"
                            v-if="showBankPaymentDetails"
                            @click="print"
                          >
                            <i class="fas fa-print"></i>
                          </button>
                        </div>
                        <div v-if="showBankPaymentDetails">
                          <p>
                            Faleminderit që keni zgjedhur shërbimet e Marimanga, për të kryer pagesën përmes bankës iu nevojiten informatat më poshtë.
                            Ju lutemi të përfshini edhe emrin, mbiemrin dhe email adresën që keni përdorur për regjistrim në menyre që ne t'iu konfirmojmë
                            pagesën sa më shpejtë.
                          </p>
                          <div id="printMe">
                            <h4>Detajet e pagesës</h4>
                            <div class>
                              <table class="table">
                                <tr>
                                  <td>Emri i bankës</td>
                                  <td>ProCredit Bank Kosovo J.S.C</td>
                                </tr>
                                <tr>
                                  <td>Adresa e bankës</td>
                                  <td>Str.George Bush No.26, Prishtina, Kosova</td>
                                </tr>
                                <tr>
                                  <td>Swift code</td>
                                  <td>MBKOXKPRXXX</td>
                                </tr>
                                <tr>
                                  <td>Emri i mbajtësit të llogarisë</td>
                                  <td>MARIMANGA SH.P.K.</td>
                                </tr>
                                <tr>
                                  <td>Adresa e mbajtësit të llogarisë</td>
                                  <td>Str, Jusuf Gervalla no 64 Prishtine 10000, Kosova</td>
                                </tr>
                                <tr>
                                  <td>Nr. i llogarisë</td>
                                  <td>1189007699000107</td>
                                </tr>
                                <tr>
                                  <td>Detajet e pagesës</td>
                                  <td>Anëtarësim ne Marimanga:
                                    {{ registrationDataSuccess ? registrationDataSuccess.last_name || registrationDataSuccess.business_number : lastName || businessNumber}},
                                    {{ registrationDataSuccess ? registrationDataSuccess.first_name || registrationDataSuccess.company_name : firstName || companyName}} -
                                    {{ registrationDataSuccess ? registrationDataSuccess.email : email }}</td>
                                </tr>
                                <tr>
                                  <td>Shuma e pagesës</td>
                                  <td>{{ registrationDataSuccess ? registrationDataSuccess.payment_data.amount : handlePrice(getTotalPrice) }} €</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div v-if="paymentType==='online'">
                          <p style="text-align:center;">
                            <img src="/img/card-logos.jpg" style="height:45px;" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="package-price">
                  <div>
                    <h2>{{ registrationDataSuccess ? registrationDataSuccess.payment_data.amount : handlePrice(getTotalPrice) }} €</h2>
                    <h5>
                      {{ selectedPackagePlan === 'annual' ? 'vjetore' : 'sezonale'}}
                      <br />
                      Pako {{ getPackageName(selectedPackage, offers) }}
                    </h5>
                  </div>
                </div>
              </div>
              <div class="row align-items-center" v-if="paymentType !== ''">
                <div class="col-12">
                  <div class="btn-next" v-if="paymentType !== 'online'">
                    <a @click="() => this.$store.state.billing.billingStep = 3">Vazhdo</a>
                  </div>
                  <div class="btn-next" v-if="paymentType === 'online'">
                    <a @click="online_purchase">Vazhdo</a>
                  </div>
                </div>
              </div>
            </div>
            <div
              role="tabpanel"
              class="tab-pane active"
              data-order="3"
              id="tab-confirmation"
              v-if="billingStep === 3"
            >
              <div class="row justify-content-center align-items-center">
                <div class="col-lg-7">
                  <div class="billing-title">
                    <h2>Konfirmoni përfundimin e aplikimit përmes e-mail</h2>
                    <img src="/img/inbox.svg" />
                    <div class="form-group">
                      <button
                        type="submit"
                        @click="() => { this.$router.push('/')}"
                      >vazhdo te ballina</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { Printd } from "printd";
import Popup from "@/components/Popup.vue";
import { mapGetters } from "vuex";
import { calculatePackagePrice } from "../utils";
import { yearsList } from "../yearsList";
import {packageTypeId} from "../enums/enum";

export default {
  name: "Billing",

  data: function() {
    return {
      yearsList: yearsList,
      packageTypeId: packageTypeId,
      frontBaseUrl: process.env.VUE_APP_FRONT_END_BASE_URL,
      showPopup: false,
      showBankPaymentDetails: false,
      isReferrerAgent : false,
      referralsList: [
     'Instagram','Facebook','Radio','TV','Agjent i Marimanges'
    ],
      errors: [],
      billing_address: '',
      billing_same: true,
      submitted: false,

    };
  },
  mounted(){
    if(this.$route.query.paymentId) {
      this.$store.dispatch('billing/getPaymentId', this.$route.query.paymentId);
      this.$store.dispatch('billing/getPaymentType', this.$route.query.paymentType);
      this.getPaymentType(this.$store.state.billing.paymentType);
      this.$store.dispatch('billing/getPaymentPage', this.$store.state.billing.payment_id);
    }
    this.$store.state.billing.referral_code_status = null;

    if(this.$route.query.referral) {

      this.$store.dispatch('billing/getReferralCode', this.$route.query.referral);
    }
  },
  created: function() {
    this.$store.state.billing.billingStep = 1;
    this.$store.state.billing.agreeToTerms = 0;
    this.$store.dispatch("billing/getFirstName", "");
    this.$store.dispatch("billing/getLastName", "");
    this.$store.dispatch("billing/getEmail", "");
    this.$store.dispatch("billing/getPhoneNumber", "");
    this.$store.dispatch("billing/getAddress", "");
    this.$store.dispatch("billing/getPersonalId", "");
    this.$store.dispatch("billing/getRegistrationNr", "");
    this.$store.dispatch("billing/getRegistrationYear", "");
    this.$store.dispatch("billing/getCarType", "");
    this.$store.dispatch("billing/getChassisNr", "");
    this.$store.dispatch("billing/getTransmission", "");
    this.$store.dispatch("billing/getReferrer", "");
    this.$store.dispatch("billing/getReferralCode", "");
    this.$store.dispatch("billing/getCompanyName", "");
    this.$store.dispatch("billing/getBusinessNumber", "");
    this.$store.dispatch("billing/getPromoCode", "");
    this.$store.state.billing.discount = null;

    // this.$store.dispatch("billing/getVolume", "");

    // this.$store.state.billing.agreeToTerms = 1;

    if (this.user()) {
      var user = this.user();

      if (user.is_business == true) {
        this.getSubscriberType("company");
      } else {
        this.getSubscriberType("individual");
      }
      this.billing_address = user.address;

      this.$store.dispatch("billing/getFirstName", user.first_name);
      this.$store.dispatch("billing/getLastName", user.last_name);
      this.$store.dispatch("billing/getEmail", user.email);
      this.$store.dispatch("billing/getPhoneNumber", user.phone_number);
      this.$store.dispatch("billing/getAddress", user.address);
      this.$store.dispatch("billing/getPersonalId", user.personal_id);
      this.$store.dispatch("billing/getCompanyName", user.company_name);
      this.$store.dispatch("billing/getBusinessNumber", user.business_number);
    }
    // this.$store.dispatch("billing/getFirstName", 'Dorjan');
    // this.$store.dispatch("billing/getLastName", 'Berishaj');
    // this.$store.dispatch("billing/getEmail", 'dorjan+@zombiesoup.com');
    // this.$store.dispatch("billing/getPhoneNumber", '049367526');
    // this.$store.dispatch("billing/getAddress", 'Rr. Nezir Mujaj');
    // this.$store.dispatch("billing/getPersonalId", '2911872288');
    // this.$store.dispatch("billing/getRegistrationNr", "01393MS");
    // this.$store.dispatch("billing/getRegistrationYear", "2016");
    // this.$store.dispatch("billing/getCarType", "Volkswagen");
    // this.$store.dispatch("billing/getChassisNr", "VWZZSA111jjj1K");
    // this.$store.dispatch("billing/getTransmission", "automatic");
    // this.$store.dispatch("billing/getVolume", "1500");
  },
  components: {
    Header,
    Footer,
    Popup
  },
  methods: {
    handlePrice(price) {
      return price < 0 ? 0 : price;
    },
    showDiscount(price){
      return price < 0;
    },
    getSelectedReferral(e){
      if(e.target.value == 'Agjent i Marimanges'){
        this.isReferrerAgent = true;
        this.$store.dispatch("billing/getIsReferrerEmail", true);
        this.$store.dispatch("billing/getReferrer", '');
      }else {
        this.isReferrerAgent = false;
        this.$store.dispatch("billing/getReferrer", e.target.value);
        this.$store.dispatch("billing/getIsReferrerEmail", false);
      }
    },
    async applyPromoCode() {
      try {
        await this.$store.dispatch("billing/getDiscount")
      } catch(e) {
        //
      }

    },
    checkReferralCode() {
      try {
        this.$store.dispatch("billing/checkReferralCode");
      } catch(e) {
        console.log(e);
      }
    },
    get_readable(messages) {
        return "";
    },
    invalid(value) {
      if(value && value !== '') {
        return false;
      }
      return true;
    },
    print(e) {
      e.preventDefault();
      const cssText = `h1 {color: black;font-family: sans-serif;}`;
      const d = new Printd();
      d.print(document.getElementById("printMe"), [cssText]);
    },
    getSecurityType(e) {
      this.$store.dispatch("billing/getSecurityType", e.target.value);
    },
    getFirstName(e) {
      this.$store.dispatch("billing/getFirstName", e.target.value);
    },
    getLastName(e) {
      this.$store.dispatch("billing/getLastName", e.target.value);
    },
    getEmail(e) {
      this.$store.dispatch("billing/getEmail", e.target.value);
    },
    getPhoneNumber(e) {
      this.$store.dispatch("billing/getPhoneNumber", e.target.value);
    },
    getPersonalId(e) {
      this.$store.dispatch("billing/getPersonalId", e.target.value);
    },
    getPromoCode(e) {
      this.$store.dispatch("billing/getPromoCode", e.target.value);
    },
    getReferrer(e) {
      this.$store.dispatch("billing/getReferrer", e.target.value);
    },
    getReferralCode(e) {
      this.$store.dispatch("billing/getReferralCode", e.target.value);
    },
    getAddress(e) {
        if(this.billing_same) {
            this.billing_address = e.target.value;
        }
      this.$store.dispatch("billing/getAddress", e.target.value);
    },
    getCompanyName(e) {
      this.$store.dispatch("billing/getCompanyName", e.target.value);
    },
    getBusinessNumber(e) {
      this.$store.dispatch("billing/getBusinessNumber", e.target.value);
    },
    getRegistrationNr(e) {
      this.$store.dispatch("billing/getRegistrationNr", e.target.value);
    },
    getCarType(e) {
      this.$store.dispatch("billing/getCarType", e.target.value);
    },
    getRegistrationYear(e) {
      this.$store.dispatch("billing/getRegistrationYear", e.target.value);
    },
    getChassisNr(e) {
      this.$store.dispatch("billing/getChassisNr", e.target.value);
    },
    // updateVolume(payload, e) {
    //   // if(e.target.value > 3000) {
    //   //   this.errors['volume'+payload] = true;
    //   //   return;
    //   // }
    // //   this.$store.dispatch("billing/updateVolume", {
    // //     index: payload,
    // //     value: e.target.value
    // //   });
    // },
    // getVolume(e) {
    //   this.$store.dispatch("billing/getVolume", e.target.value);
    // },
    getTransmission(e) {
      this.$store.dispatch("billing/getTransmission", e.target.value);
    },
    getPaymentType(value) {
        this.$store.dispatch("billing/getPaymentType", value);
        this.showBankPaymentDetails = value === 'bank';
    },
    getSubscriberType(value) {
      this.$store.commit("billing/GET_PROMO_CODE_ERROR", null);
      this.$store.dispatch("billing/getSubscriberType", value);
    },
    get_error(index) {
      return this.errors[index];
    },
    requestRegister(e) {
        e.preventDefault();

        this.errors = [];
        var vm = this;

        if(!this.billing_same)
        {
            if(this.invalid(this.billing_address))
            {
                this.errors['billing_address'] = true;
            }
        }
      if (this.subscriberType === "individual") {
        if (!this.firstName) {
          this.errors["firstName"] = true;
        }
        if (!this.lastName) {
          this.errors["lastName"] = true;
        }
        if (!this.email) {
          this.errors["email"] = true;
        }
        if (!this.phoneNumber) {
          this.errors["phoneNumber"] = true;
        }
        if (!this.personalId) {
          this.errors["personalId"] = true;
        }
        if (!this.address) {
          this.errors["address"] = true;
        }
        if(this.selectedPackage !== 7)
        {
            if (!this.registrationNr) {
                this.errors["registrationNr"] = true;
            }
            if (!this.carType) {
                this.errors["carType"] = true;
            }
            if (!this.registrationYear) {
                this.errors["registrationYear"] = true;
            }
            if (!this.chassisNr) {
                this.errors["chassisNr"] = true;
            }
            if (!this.transmission) {
                this.errors["transmission"] = true;
            }
        }
      }
      if (this.subscriberType === "company") {
        if (!this.email) {
          this.errors["email"] = true;
        }
        if (!this.companyName) {
          this.errors["companyName"] = true;
        }
        if (!this.businessNumber) {
          this.errors["businessNumber"] = true;
        }
        if (!this.phoneNumber) {
          this.errors["phoneNumber"] = true;
        }
        if (!this.address) {
          this.errors["address"] = true;
        }
        if(this.selectedPackage !== 7)
        {
            $.each(this.vehicles, function(key, vehicle) {
                if (!vehicle.registrationNr) {
                    vm.errors["registrationNr" + key] = true;
                }
                if (!vehicle.carType) {
                    vm.errors["carType" + key] = true;
                }
                if (!vehicle.registrationYear) {
                    vm.errors["registrationYear" + key] = true;
                }
                if (!vehicle.transmission) {
                    vm.errors["transmission" + key] = true;
                }
              if (!vehicle.vehicle_owner_name) {
                vm.errors["vehicle_owner_name" + key] = true;
              }
          });
        }
      }
      if (Object.keys(this.errors).length > 0) {
        this.$store.state.billing.disable_submit_button = false;
        return;
      }

      if (this.user()) {
        this.$store.dispatch("billing/addPackage", {
            billing_address: this.billing_address,
            amount: this.getTotalPrice,
            promo_code: this.discount ? this.discount.code : null,
            active_offer: this.currentPromotion ? this.currentPromotion.id : null
        });
      } else {
        this.$store.dispatch("billing/requestRegister", {
            billing_address: this.billing_address,
            amount: this.getTotalPrice,
            promo_code: this.discount ? this.discount.code : null,
            active_offer: this.currentPromotion ? this.currentPromotion.id : null
        });
      }
    //   window.scrollTo(0,0);
    },
    online_purchase() {
      this.$store.dispatch("billing/payOnline").then(function(response) {

          if(response.data.url) {
            window.location.href = response.data.url;
          } else {
              alert("Ndodhi një gabim. Ju lutem provoni përsëri!")
          }
      });
    },
    find_index(vehicles, j) {
      let result = 0;
      let index = 0;
      $.each(vehicles, function(key, value) {
        if (Number(key) === Number(j)) {
          result = index;
        } else {
          index++;
        }
      });
      return result + 1;
    },
    removeVehicleAt(value, e) {
      e.preventDefault();
      this.$store.dispatch("billing/removeVehicleAt", value);
    },
    getVehicleCount(value, e) {
      e.preventDefault();
      this.$store.dispatch("billing/getVehicleCount", value);
    },
    updateRegistratioNr(payload, e) {
      this.$store.dispatch("billing/updateRegistratioNr", {
        index: payload,
        value: e.target.value
      });
    },
    updateCarType(payload, e) {
      this.$store.dispatch("billing/updateCarType", {
        index: payload,
        value: e.target.value
      });
    },
    updateRegistrationYear(payload, e) {
      this.$store.dispatch("billing/updateRegistrationYear", {
        index: payload,
        value: e.target.value
      });
    },
    updateChassisNr(payload, e) {
      this.$store.dispatch("billing/updateChassisNr", {
        index: payload,
        value: e.target.value
      });
    },
    updateTransmission(payload, e) {
      this.$store.dispatch("billing/updateTransmission", {
        index: payload,
        value: e.target.value
      });
    },
    getShowModal(value, e) {
      e.preventDefault();

      window.open(`${this.frontBaseUrl}/pdf/${this.selectedPackage}.pdf`, "_blank");
    },
    toggleAgreeToTerms() {
      this.$store.dispatch("billing/toggleAgreeToTerms");
      this.showPopup = !this.showPopup
    },
    getPackageName(selectedPackage, offers) {
      const selectedOffer = offers.find(obj => obj.id === selectedPackage);

      if (selectedPackage === this.packageTypeId.PERSONALE) {
        return 'personale';
      }

      if (selectedOffer) {
        return selectedOffer.name;
      }

      return 'No package found!'
    },
    calculatePackagePrice
  },
  computed: {
    ...mapGetters({
      registrationDataSuccess: "billing/registrationDataSuccess",
      agreeToTerms: "billing/agreeToTerms",
      securityType: "billing/securityType",
      firstName: "billing/firstName",
      lastName: "billing/lastName",
      email: "billing/email",
      phoneNumber: "billing/phoneNumber",
      personalId: "billing/personalId",
      referrer: "billing/referrer",
      referral_code: "billing/referral_code",
      address: "billing/address",
      promo_code: "billing/promoCode",
      discount: "billing/discount",
      payment_id: "billing/payment_id",
      companyName: "billing/companyName",
      businessNumber: "billing/businessNumber",
      registrationNr: "billing/registrationNr",
      carType: "billing/carType",
      registrationYear: "billing/registrationYear",
      chassisNr: "billing/vehicle_owner_name",
      promoCode: "billing/promoCode",
      transmission: "billing/transmission",
      paymentType: "billing/paymentType",
      selectedPackage: "selected/selectedPackage",
      selectedPackagePlan: "selected/offerPlanType",
      subscriberType: "billing/subscriberType",
      vehicleCount: "billing/vehicleCount",
      vehicles: "billing/vehicles",
      registrationMessages: "billing/registrationMessages",
      billingStep: "billing/billingStep",
      offers: "subscriptions/offers",
      showModal: "billing/showModal",
      brandNames: "billing/brandNames",
      submitSuccess: "billing/submitSuccess",
      currentPromotion: "account/currentPromotion",
      promoCodeError: "billing/promoCodeError"
    }),
    disableReferralCodeInput() {
      return !this.$store.state.billing.referrer && this.isReferrerAgent === false;
    },
    disableSubmitButton() {
      return this.$store.state.billing.disable_submit_button;
    },
    getTotalPrice()
    {
      let vehicleCount =  this.$store.state.billing.vehicleCount;
      return this.calculatePackagePrice(this.selectedPackage, this.selectedPackagePlan, this.currentPromotion, this.discount) * vehicleCount
    },
    getReferralInputClass() {
      return {
        'border border-success': this.$store.state.billing.referral_code_status == true,
        'border-danger': this.$store.state.billing.referral_code_status === false,
      }
    }

  },
  beforeMount()
  {
    this.$store.commit("billing/GET_PROMO_CODE_ERROR", null);
    this.$store.dispatch("subscriptions/getOffers");
    this.$store.state.selected.offerPlanType = this.$route.params.plan;
    this.$store.state.selected.selectedPackage = parseInt(this.$route.params.package);
    
    if (this.$route.params.package == 7 && this.$route.params.plan === "seasonal")
    {
      this.$store.state.selected.offerPlanType = "annual";
      this.$router.push("/billing/7/annual");
    }
  }
};
</script>